import { useTracking } from '@change-corgi/core-react/tracking';

export const useCtaSection = () => {
	const track = useTracking();

	return {
		actions: {
			trackSapClick: () => {
				void track('topic_sitemap_sap_click');
			},
		},
	};
};
